"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CakeCover = void 0;
var GameVars_1 = require("../../../GameVars");
var BoardCell_1 = require("./BoardCell");
var BoardManager_1 = require("../BoardManager");
var AudioManager_1 = require("../../../AudioManager");
var AchievementsManager_1 = require("../../../AchievementsManager");
var GameConstants_1 = require("../../../GameConstants");
var CakeCover = /** @class */ (function (_super) {
    __extends(CakeCover, _super);
    function CakeCover(scene, p, isMisteryItem, itemPurchased, isGameReloaded) {
        var _this = this;
        var x = p.c * BoardCell_1.BoardCell.WIDTH;
        var y = p.r * BoardCell_1.BoardCell.HEIGHT;
        _this = _super.call(this, scene, x, -GameVars_1.GameVars.gameHeight / 2 - BoardCell_1.BoardCell.HEIGHT / 2, "texture_atlas_1", isMisteryItem ? "cover_deluxe" : (itemPurchased ? "cover_bought" : "cover")) || this;
        _this.p = p;
        _this.isMisteryItem = isMisteryItem;
        _this.itemPurchased = itemPurchased;
        _this.setOrigin(.5, .75);
        isGameReloaded = isGameReloaded || false;
        _this.scene.time.delayedCall(300, function () {
            AudioManager_1.AudioManager.playSound("cake_cover_lands");
        }, [], _this);
        if (isGameReloaded) {
            _this.x = x;
            _this.y = y;
        }
        else {
            _this.scene.tweens.add({
                targets: _this,
                y: y,
                ease: Phaser.Math.Easing.Bounce.Out,
                duration: 850
            });
        }
        _this.setInteractive();
        _this.on("pointerdown", _this.onDownCover, _this);
        return _this;
    }
    CakeCover.prototype.shake = function () {
        this.setScale(1.05);
        this.scene.tweens.add({
            targets: this,
            angle: 8,
            ease: Phaser.Math.Easing.Linear,
            duration: 50,
            yoyo: true,
            onComplete: function () {
                if (this.scene) {
                    this.scene.tweens.add({
                        targets: this,
                        angle: -8,
                        ease: Phaser.Math.Easing.Linear,
                        duration: 50,
                        yoyo: true,
                        onComplete: function () {
                            this.setScale(1);
                        },
                        onCompleteScope: this
                    });
                }
            },
            onCompleteScope: this
        });
    };
    CakeCover.prototype.onDownCover = function () {
        if ((GameVars_1.GameVars.paused || GameVars_1.GameVars.carouselActive) && !GameVars_1.GameVars.gameData.tutorialPhase) {
            return;
        }
        if (this.isMisteryItem) {
            AchievementsManager_1.AchievementsManager.updateAchievement(GameConstants_1.GameConstants.ACHIEVEMENTS_OPEN_MINSTERY);
        }
        else if (!this.itemPurchased) {
            AchievementsManager_1.AchievementsManager.updateAchievement(GameConstants_1.GameConstants.ACHIEVEMENTS_OPEN_BOX);
        }
        BoardManager_1.BoardManager.onDownCover(this.p, this.isMisteryItem, this.itemPurchased);
        AudioManager_1.AudioManager.playSound("cake_revealed");
    };
    return CakeCover;
}(Phaser.GameObjects.Image));
exports.CakeCover = CakeCover;
